import UserManagementSvg from './component.jsx'
export default UserManagementSvg
